import { Component as PComponent } from '~preact';
import { ModalContext } from "../Modal";

/**
 * A public higher-order component to access the imperative API
 */
export const withModalContext = Component => {
	class HOC extends PComponent {
		render({...props}) {
			return (
				<ModalContext.Consumer>
					{(modalContext) => (
						<Component
							modalContext={modalContext}
							{...this.props}
						/>
					)}
				</ModalContext.Consumer>
			);
		}

		static get displayName() {
			return "withModalContext(" + (Component.displayName || Component.name) + ")"
		}

		static get wrappedComponent() {
			return Component;
		}
	}

	return HOC;
};

export default withModalContext;
